import { useCurrentBrandQuery } from '@/hooks/queries/use-current-brand-query';
import api from '@/libs/axiosInstance';
import type { ApiResponse, DashboardOverviewResponse } from '@fluenceur/types';
import { useQuery } from '@tanstack/react-query';
import { dashboardOverviewKeys } from './dashboard-overview-keys';

export const DASHBOARD_OVERVIEW_PATH = '/dashboard/overview';

/**
 * What waits on the current brand (`GET /dashboard/overview`). Ignores the
 * overview filters on purpose: the to-do card describes the brand, not the
 * period or programme being looked at. Each source carries its own status, so
 * the request only fails as a whole when the server cannot be reached.
 */
export const useDashboardOverviewQuery = () => {
  const { data: brand } = useCurrentBrandQuery();
  const brandId = brand?.id ?? '';

  return useQuery<DashboardOverviewResponse, Error>({
    queryKey: dashboardOverviewKeys.brand(brandId),
    queryFn: async () => {
      const { data } =
        await api.get<ApiResponse<DashboardOverviewResponse>>(DASHBOARD_OVERVIEW_PATH);
      return data.data as DashboardOverviewResponse;
    },
    enabled: !!brandId,
  });
};
